<section *ngIf="{
  processingSubmit: processingSubmit$ | async
} as headerContext" class="page-heading">

  <button *ngIf="!headerContext.processingSubmit" [mat-dialog-close]="undefined" class="close-button" mat-icon-button
    type="button" tabindex="-1">
    <mat-icon class="notranslate">close</mat-icon>
  </button>

  <h1 class="heading">Review Bank Account Details</h1>
  <h2 class="page-sub-header">
    Please review all the information.
    <ng-container *ngIf="isGpSide$ | async">
      <br>
      Signature users will be notified and have to approve the creation of this bank account.
    </ng-container>
  </h2>
</section>

<terra-loader *ngIf="processingSubmit$ | async; else review" class="submit-loader"></terra-loader>
<ng-template #review>
  <section *ngIf="account$ | async as account" class="account-details-section">
    <h2 class="section-title">Account Details
      <button (click)="backToFirstStep()" class="edit-button cov-button" color="primary" mat-button>
        <mat-icon class="notranslate">edit</mat-icon>
        <span class="edit-text">Edit Details</span>
      </button>
    </h2>

    <div class="section-content">
      <div class="details-list">
        <div class="column">
          <div class="item-content">
            <mat-icon class="icon-with-background notranslate">paid</mat-icon>
            <span>
              <label>Nickname: </label>{{account.accountNickname}}
            </span>
          </div>

          <!--          <div class="item-content">-->
          <!--            <mat-icon class="icon-with-background notranslate">person</mat-icon>-->
          <!--            <span>-->
          <!--              <label>Owner: </label>XXX Placeholder-->
          <!--            </span>-->
          <!--          </div>-->

          <div class="item-content" *ngIf="account?.holding">
            <mat-icon class="icon-with-background notranslate">location_city</mat-icon>
            <span>
              <label>Asset/Fund: </label>{{account?.holding?.name}}
            </span>
          </div>

          <div class="item-content">
            <mat-icon class="icon-with-background notranslate">work</mat-icon>
            <span>
              <label>Type: </label>{{account.accountType | enumString : UnitAccountType}}
            </span>
          </div>
        </div>
        <div class="column">
          <!-- column placeholder -->
        </div>
      </div>
    </div>
  </section>


  <form (ngSubmit)="submit()" *ngIf="{
      processingSubmit: processingSubmit$ | async
    } as formContext" [formGroup]="pageForm" id="bankAccountForm">

    <section class="agreements-section">
      <h4>Check these to indicate that you have read and agree to the following:</h4>
      <div class="agreements-section-checkbox">
        <mat-checkbox color="primary" formControlName="termsOfServiceAgreement">
          I have read and accepted the
          <a href="{{termType.getUrl(termType.ElectronicDisclosureAndConsent)}}"
            target="_blank">{{termType.toString(termType.ElectronicDisclosureAndConsent)}}</a>,
          <a *ngIf="(unitAccountThreadProvider$ | async); else choiceTerms" href="{{termType.getUrl(termType.ThreadAccountTermsAndConditions)}}"
             target="_blank">{{termType.toString(termType.ThreadAccountTermsAndConditions)}}</a>,
          <ng-template #choiceTerms>
            <a href="{{termType.getUrl(termType.DepositAccountTermsAndConditions)}}"
            target="_blank">{{termType.toString(termType.DepositAccountTermsAndConditions)}}</a>,
          </ng-template>
          <br />
          <a href="{{termType.getUrl(termType.ClientPrivacyPolicy)}}"
            target="_blank">{{termType.toString(termType.ClientPrivacyPolicy)}}</a>,
          <a href="{{termType.getUrl(termType.ClientTermsOfService)}}"
            target="_blank">{{termType.toString(termType.ClientTermsOfService)}}</a>,
          and I consent to the use of electronic records in connection with this application.
        </mat-checkbox>
        <mat-error *ngIf="pageForm.get('termsOfServiceAgreement').hasError('required') && (isSubmitAttempt$ | async)"
          class="error-message">
          Please accept the above terms
        </mat-error>
      </div>
    </section>

    <section class="form-footer">
      <button [disabled]="formContext.processingSubmit" class="cov-button continue-button" color="primary"
        form="bankAccountForm" mat-flat-button type="submit">
        Open Bank Account
      </button>

      <button [disabled]="formContext.processingSubmit" class="cancel-button cov-button" mat-stroked-button
        [mat-dialog-close]="undefined">
        Cancel
      </button>
    </section>
  </form>
</ng-template>
